/**
 * nuqs-based URL state management for audit filters
 */

import {
  createSerializer,
  parseAsArrayOf,
  parseAsIsoDateTime,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';
import { SortOrder } from 'types/generated/graphql';

import { getDefaultDateRange } from './utils';

const defaultDateRange = getDefaultDateRange();

const SORT_ORDER_VALUES = [SortOrder.Ascending, SortOrder.Descending] as const;

/**
 * Point/StorageUnit view filters
 */
export const pointFiltersParser = {
  pointId: parseAsString.withDefault(''),
  storageUnitId: parseAsString,
  eventTypes: parseAsArrayOf(parseAsString).withDefault([]),
  dateFrom: parseAsIsoDateTime.withDefault(defaultDateRange.from),
  dateTo: parseAsIsoDateTime.withDefault(defaultDateRange.to),
  page: parseAsString.withDefault('1'),
  sortOrder: parseAsStringLiteral(SORT_ORDER_VALUES).withDefault(
    SortOrder.Descending
  ),
};

export function usePointFilters() {
  return useQueryStates(pointFiltersParser, {
    history: 'push',
  });
}

export const serializePointFilters = createSerializer(pointFiltersParser);

/**
 * Content view filters
 */
export const contentFiltersParser = {
  trackingIdentifier: parseAsString.withDefault(''),
  eventTypes: parseAsArrayOf(parseAsString).withDefault([]),
  dateFrom: parseAsIsoDateTime.withDefault(defaultDateRange.from),
  dateTo: parseAsIsoDateTime.withDefault(defaultDateRange.to),
  page: parseAsString.withDefault('1'),
  sortOrder: parseAsStringLiteral(SORT_ORDER_VALUES).withDefault(
    SortOrder.Descending
  ),
};

export function useContentFilters() {
  return useQueryStates(contentFiltersParser, {
    history: 'push',
  });
}

export const serializeContentFilters = createSerializer(contentFiltersParser);

/**
 * Courier view filters
 */
export const courierFiltersParser = {
  courierPersonalId: parseAsString.withDefault(''),
  tenantSubjectId: parseAsString,
  eventTypes: parseAsArrayOf(parseAsString).withDefault([]),
  dateFrom: parseAsIsoDateTime.withDefault(defaultDateRange.from),
  dateTo: parseAsIsoDateTime.withDefault(defaultDateRange.to),
  page: parseAsString.withDefault('1'),
  sortOrder: parseAsStringLiteral(SORT_ORDER_VALUES).withDefault(
    SortOrder.Descending
  ),
};

export function useCourierFilters() {
  return useQueryStates(courierFiltersParser, {
    history: 'push',
  });
}

export const serializeCourierFilters = createSerializer(courierFiltersParser);

/**
 * Contact view filters
 */
export const contactFiltersParser = {
  contact: parseAsString.withDefault(''),
  eventTypes: parseAsArrayOf(parseAsString).withDefault([]),
  dateFrom: parseAsIsoDateTime.withDefault(defaultDateRange.from),
  dateTo: parseAsIsoDateTime.withDefault(defaultDateRange.to),
  page: parseAsString.withDefault('1'),
  sortOrder: parseAsStringLiteral(SORT_ORDER_VALUES).withDefault(
    SortOrder.Descending
  ),
};

export function useContactFilters() {
  return useQueryStates(contactFiltersParser, {
    history: 'push',
  });
}

export const serializeContactFilters = createSerializer(contactFiltersParser);
